import { OPREATOR_AGREEMENT_STATE, BUSINESS_AGREEMENT_STATE } from "../config/actionTypes";

const initialState = {
    OperatorState: 0,
    BusinessState: 0
}

const VerifyagreeReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case OPREATOR_AGREEMENT_STATE:
            return { ...state, OperatorState: payload };
        case BUSINESS_AGREEMENT_STATE:
            return { ...state, BusinessState: payload }
        default:
            return state;
    }
}

export default VerifyagreeReducer;